const Dot = () => (
    <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="flex-shrink-0"
    >
        <circle
            cx="4"
            cy="4"
            r="2"
            fill="white"
            stroke="#C3CCD9"
            strokeWidth="4"
        />
    </svg>
);
export default Dot;
